import { Content, Portal } from '@radix-ui/react-dropdown-menu';
import { ComponentPropsWithoutRef } from 'react';
import { cn } from '@/shared/lib/cn';
import './dropdown.scss';

type Props = ComponentPropsWithoutRef<typeof Content>;
export const DropdownContent = ({ className, sideOffset = 4, ...props }: Props) => {
    return (
        <Portal>
            <Content
                data-testid="dropdown-content"
                sideOffset={sideOffset}
                className={cn('dropdown__content', className)}
                {...props}
            />
        </Portal>
    );
};
